import PaginationComponent from '@/components/common/PaginationComponent';
import LinkTag from '@/components/common/link-tag';
import MedicineDictionary from '@/entities/medicine-dictionary/ui/MedicineDictionary';
import { createMedicineDictionaryDetailUrl } from '@/entities/medicine-dictionary/util';
import { SearchTotalMedicineDictionaryViewModel } from '../hook/useSearchTotalMedicineDictionaryViewModel';

interface Props {
  viewModel: SearchTotalMedicineDictionaryViewModel;
}

const SearchTotalMedicineDictionary = (props: Props) => {
  return (
    <div className='flex flex-col gap-[16px] px-[24px] pt-[32px] pb-[80px]'>
      <div className='flex flex-col'>
        <h2 className='typography-ui-20sb mb-4 text-gray-700 '>전체 약품</h2>
        <div className='grid grid-cols-1 gap-[28px] md:grid-cols-2' suppressHydrationWarning>
          {props.viewModel.medicineDictionaryItems.map((item) => (
            <LinkTag
              key={item.getPublicId()}
              href={`${createMedicineDictionaryDetailUrl(item)}`}
              onClickNavigateToScreen={props.viewModel.onClickMedicineDictionary(item)}
            >
              <MedicineDictionary
                title={item.getBasicInfoName()}
                description={item.getPharmaceuticalEffectLiteracy()}
                summary={item.getWholeSummary()}
                image={item.getRepresentativeImage()}
                imageAlt={item.getSimplifiedName()}
              />
            </LinkTag>
          ))}
        </div>
      </div>
      <PaginationComponent
        baseUrl={props.viewModel.paginationBaseUrl}
        queries={props.viewModel.queries}
        currentPage={props.viewModel.currentPage}
        perPage={5}
        totalPage={props.viewModel.totalPage}
        scroll={false}
      />
    </div>
  );
};

export default SearchTotalMedicineDictionary;
